/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import styles from './TransactionHistory.module.scss';
import { useTranslation } from 'react-i18next';
import { useI18nLabels } from '@/utils/useI18nLabels';

const { Box, SubTitle, Table, Badge, Icon } = vp;

type TransactionsHistoryProps = {
  upcomingTransfers?: TransactionListType;
  completedTransfers?: TransactionListType;
  transactions: { [key: number]: vp.AccountTransferSchedule };
};

type TransactionListType = {
  [index: number]: vp.AccountTransferScheduleTransfers;
};

type FC = FunctionComponent<TransactionsHistoryProps>;

const TransactionsHistory: FC = (props: TransactionsHistoryProps) => {
  const { upcomingTransfers, completedTransfers, transactions } = props;
  const transaction = Object.values(transactions)[0];
  const [status, setStatus] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [transactionsList, setTransactionsList] = useState<TransactionListType>({});
  const [filteredLists, setFilteredLists] = useState<TransactionListType>({});
  const [tempTransactions, setTempTransactions] = useState<vp.TemporaryAccountTransferScheduleTransfers>({});
  const { t } = useTranslation('translations', { keyPrefix: 'ClientAccounts.Schedule.Details.Transactions' });
  const { transferTypeLabelMapper } = useI18nLabels();

  useEffect(() => {
    let temp = 0;
    const nonExpandedRow = Object.values(filteredLists).map((data) => ({
      ...data,
      id: (++temp).toString(),
      isExpanded: false,
      isVisible: true,
      class: 'row',
    }));
    const allRows = nonExpandedRow.reduce((acc, data) => {
      const WithdrawTransactionIDs = data.WithdrawTransactionIDs && data.WithdrawTransactionIDs.split(', ');
      const AccountTransferIDs = data.AccountTransferIDs && data.AccountTransferIDs.split(', ');
      const expandedData = (
        (transaction?.RecipientClientAccountIDSplit && JSON.parse(transaction.RecipientClientAccountIDSplit)) ||
        []
      ).map((item: any) => ({
        ...data,
        expandedId: data.id,
        isVisible: false,
        NumberOfRecipients: item.ClientAccountID,
        WithdrawTransactionID: WithdrawTransactionIDs && WithdrawTransactionIDs.shift(),
        AccountTransferID: AccountTransferIDs && AccountTransferIDs.shift(),
        Amount: item.Amount || (item.Percentage / 100) * transaction.Amount,
        class: 'expandedRow',
      }));

      return {
        ...acc,
        [data.id]: [data, ...expandedData],
      };
    }, {});

    setTempTransactions(allRows);
  }, [filteredLists]);

  // create lists
  useEffect(() => {
    if (upcomingTransfers || completedTransfers) {
      const upcomingTransactions = Object.values(upcomingTransfers || {});
      const completedTransactions = Object.values(completedTransfers || {});

      const mergedTransactions = Object.values(upcomingTransactions.concat(completedTransactions))
        .sort((a, b) => (a.TransferDate < b.TransferDate ? -1 : 1))
        .reduce(
          (accumulator, trasanctions, index) => ({
            ...accumulator,
            [index]: { ...trasanctions },
          }),
          {},
        );
      setTransactionsList(mergedTransactions);
      setStatus('');
      setSearchTerm('');
    }
  }, [upcomingTransfers, completedTransfers]);
  const search = () => {
    const keys = ['Amount'];
    setFilteredLists(
      Object.values(transactionsList || {}).filter(
        (data) =>
          (status === '' || status === 'all' || data.Status === status) &&
          (searchTerm === '' ||
            keys.some((key) =>
              data[key as keyof vp.AccountTransferScheduleTransfers]?.toString().toLowerCase().includes(searchTerm),
            ) ||
            vp
              .joinItemsComma([
                data.FundingTransactionID,
                data.AccountTransferID,
                data.WithdrawTransactionID,
                data.AccountTransferIDs,
                data.WithdrawTransactionIDs,
              ])
              .includes(searchTerm)),
      ),
    );
  };
  // search form
  useEffect(() => {
    search();
  }, [transactionsList]);

  const onExpand = (id: string) => {
    setTempTransactions((prevTempTransactions) => {
      const updatedTransactions: vp.TemporaryAccountTransferScheduleTransfers = Object.fromEntries(
        Object.entries(prevTempTransactions).map(([key, dataArray]) => [
          key,
          dataArray.map((item: any) => {
            if (item.id === id) {
              if (item.expandedId === id) {
                return { ...item, isExpanded: !item.isExpanded, isVisible: !item.isVisible };
              }
              return { ...item, isExpanded: !item.isExpanded };
            }
            return item;
          }),
        ]),
      );

      return updatedTransactions;
    });
  };

  const tables = Object.values(tempTransactions).map((data, index) => {
    const tableProps: vp.TableProps = {
      id: `transactions-${index}`,
      name: `transactions-${index}`,
      columns: {
        startDate: { header: t('transactionDate'), align: 'left' },
        numberOfRecipients: { header: t('numberOfRecipients'), align: 'left' },
        fundID: { header: t('FundID.label'), align: 'left' },
        status: { header: t('status'), align: 'left' },
        totalAmount: { header: t('totalAmount'), align: 'left' },
        seeSplit: { header: '', align: 'left', visiblity: createSplitClientAccounts() > 1 },
      },
      rows: Object.values(data)?.map((e: any) => ({
        ID: e.ScheduledTransferID,
        startDate: e.TransferDate,
        numberOfRecipients: e.NumberOfRecipients || createSplitClientAccounts(),
        fundID:
          e.class === 'expandedRow' ? (
            <>
              <span className={styles.transactionID}>{t('FundID.valueTransfer')}</span> {e.AccountTransferID || '-'}
              {transaction?.TransferType !== 'fund-transfer' && (
                <div>
                  <span className={styles.transactionID}>{t('FundID.valueWithdraw')}</span>{' '}
                  {e.WithdrawTransactionID || '-'}
                </div>
              )}
            </>
          ) : transaction?.TransferType !== 'transfer-withdraw' ? (
            <>
              <span className={styles.transactionID}>{t('FundID.valueFund')}</span>
              {e.FundingTransactionID || '-'}
            </>
          ) : (
            <></>
          ),
        status: (
          <Badge
            label={vp.capitalizeFirstLetterOfWords(e.Status || '')}
            hasIcon
            color={vp.GetColorStatus(e.Status || '')}
          />
        ),
        totalAmount: `$ ${Number(e.Amount).toFixed(2)} ${e.Currency} `,
        seeSplit: e.NumberOfRecipients ? (
          <></>
        ) : (
          <div
            aria-hidden="true"
            style={{ display: 'flex', justifyContent: 'flex-end' }}
            onClick={() => {
              onExpand(e.id);
            }}
          >
            <p style={{ paddingRight: '10px' }}>{t('seeSplit')}</p>
            {e.isExpanded ? (
              <Icon icon="angleTop" size="sm" height="17px" width="17px" />
            ) : (
              <Icon icon="angleDown2" size="sm" height="17px" width="17px" />
            )}
          </div>
        ),
        isVisible: e.isVisible ? 'true' : 'false',
        class: e.class,
      })),

      isExpandable: true,
    };
    return tableProps;
  });

  return (
    tables && (
      <Box flx="col">
        <SubTitle subTitle={t('title')} />
        <div className={styles.subTitleMarginBottom} />
        {tables.map((e) => {
          const title = e.rows.reduce((acc, data) => {
            if (data.class === 'row') {
              return `${acc}${transferTypeLabelMapper(transaction.TransferType, '')} - ${data.ID}`;
            }
            return acc;
          }, '');

          return (
            <div className={styles.tableContainer}>
              <Table {...e} variant="splitPayment" title={title} />
            </div>
          );
        })}
      </Box>
    )
  );

  function createSplitClientAccounts() {
    const RecipientClientAccountIDSplit = transaction?.RecipientClientAccountIDSplit
      ? JSON.parse(transaction?.RecipientClientAccountIDSplit).map((item: any) => item.ClientAccountID)
      : [transaction?.RecipientClientAccountID];
    return RecipientClientAccountIDSplit.length;
  }
};

export default TransactionsHistory;
